import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';
import config from 'config/index';

// types
import { EUserType } from 'types/accessControll.types';
import type { TScoringLanguagePreference } from 'types/user.types';
import type { TAdminUser } from 'types/user.types';

const reducerPath = 'admins' as const;
const path = 'v1/admins' as const;

export const adminsApi = createApi({
  reducerPath: reducerPath,
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.VITE_BACKEND_URL}/${path}`,
  }),
  endpoints: (builder) => ({
    getAllAdmins: builder.query<{ admins: (TAdminUser & { label: string; value: string })[] }, void>({
      query: () => ({
        url: `/get-all`,
        method: 'GET',
        headers: {
          'X-Access-Control': EUserType.HUBERT,
        },
      }),
    }),

    updateScoringLanguagePreference: builder.mutation<any, any>({
      query: (preference: TScoringLanguagePreference) => ({
        url: `/update-scoring-language-preference`,
        method: 'POST',
        data: {
          preference,
        },
        headers: {
          'X-Access-Control': EUserType.HUBERT,
        },
      }),
    }),
  }),
});

export const {
  // Queries
  useGetAllAdminsQuery,

  // Mutations
  useUpdateScoringLanguagePreferenceMutation,
} = adminsApi;
